import Breadcrumb from '#client/components/common/Breadcrumb/Breadcrumb';
import { useTransferStore } from '#client/stores/transfer/useTransferStore';
import { Spinner } from '@shopify/polaris';
import { useMemo } from 'react';

export default function TransferBreadcrumbs() {
    // Zustand store for transfer mode and id
    const mode = useTransferStore.use.mode();
    const transferId = useTransferStore.use.displayTransferId();

    const breadcrumbItems = useMemo(
        () =>
            mode === 'create'
                ? [{ label: 'Store to Store Transfers', url: '/transfers' }]
                : [{ label: 'Store to Store Transfers', url: '/transfers' }, { label: !transferId ? <Spinner size="small" /> : (transferId && transferId.toString()) || 'Not Saved' }],
        [mode, transferId]
    );

    return <Breadcrumb items={breadcrumbItems} />;
}
